import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ProjectSummaryParams {
  custMode: { external: boolean; internal: boolean; absense: boolean };
  cust?: number | null;
  proj?: number | null;
  act?: number | null;
  per: string;
  type: string;
  selection: string;
  from: string;
  to: string;
}

export interface ProjectSummaryItem {
  customername: string;
  endcustomer?: string;
  project_name?: string;
  external_project_name?: string;
  name?: string;
  activity_name?: string;
  external_activity_name?: string;
  start_date?: string;
  stop_date?: string;
  price?: number;
  activity_id?: number;
  contractor?: string;
  employee_id?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ProjectSummaryService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  getProjectSummary(params: ProjectSummaryParams): Observable<ProjectSummaryItem[]> {
    let httpParams = new HttpParams()
      .set('custMode', JSON.stringify(params.custMode))
      .set('per', params.per)
      .set('type', params.type)
      .set('selection', params.selection);

    if (params.cust !== null && params.cust !== undefined) {
      httpParams = httpParams.set('cust', String(params.cust));
    }
    if (params.proj !== null && params.proj !== undefined) {
      httpParams = httpParams.set('proj', String(params.proj));
    }
    if (params.act !== null && params.act !== undefined) {
      httpParams = httpParams.set('act', String(params.act));
    }

    return this.http.get<ProjectSummaryItem[]>(`/api/projsummary/${params.from}/${params.to}`, {
      params: httpParams,
    });
  }
}
